import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { useResponsive } from "@/hooks/useResponsive";
import { useNotShowMobileWarning } from "@/stores/notShowMobileWarningAtom";

export const MobileWarningModal = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [notShowMobileWarning, setNotShowMobileWarning] =
    useNotShowMobileWarning();

  const handleClose = () => {
    setNotShowMobileWarning(true);
  };

  return (
    <Dialog open={isMobile && !notShowMobileWarning}>
      <DialogContent
        hideCloseButton
        className="w-full max-w-md rounded-xl p-6"
        onEscapeKeyDown={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
      >
        <DialogTitle className="mb-2 text-base font-medium text-black">
          {t("mobile.warning.title")}
        </DialogTitle>

        <DialogDescription className="text-sm leading-relaxed text-black/70">
          {t("mobile.warning.description.line1")}
          <br />
          <br />
          {t("mobile.warning.description.line2")}
        </DialogDescription>

        <div className="mt-6 flex justify-center">
          <Button onClick={handleClose} size="sm">
            {t("common.close")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
